<template>
    <div class="cart-page cart-page--delivery">
        <div class="container">
            <div class="cart-page__row row">
                <keep-alive>
                    <step-delivery v-if="showDeliveryStep"></step-delivery>
                </keep-alive>
                <keep-alive>
                    <step-payment v-if="showPaymentStep"></step-payment>
                </keep-alive>
                <keep-alive>
                    <step-final v-if="showFinalStep"></step-final>
                </keep-alive>

                <order-summary></order-summary>

            </div>
        </div>
    </div>
</template>

<script>
    import StepDelivery from "@/components/Checkout/StepDelivery";
    import StepPayment from "@/components/Checkout/StepPayment";
    import StepFinal from "@/components/Checkout/StepFinal";
    import OrderSummary from "@/components/Checkout/Summary";
    import StoreCheckout from "@/store/modules/Checkout"
    import {mapState, mapActions} from "vuex"

    export default {
        components: {
            StepFinal,
            StepDelivery,
            StepPayment,
            OrderSummary,
        },
        created() {
            this.$store.registerModule('StoreCheckout', StoreCheckout);
        },
        computed: {
            ...mapState('StoreCheckout', ['currentStep']),

            showDeliveryStep() {
                return this.currentStep === 'delivery';
            },
            showPaymentStep() {
                return this.currentStep === 'payment';
            },
            showFinalStep() {
                return this.currentStep === 'final';
            }
        },
        methods: {
            ...mapActions('StoreCheckout', ['nextStep']),
            ...mapActions('StoreCheckout', ['setStep']),
        },
        data() {
            return {

            }
        }
    }
</script>